export default {
  addon: require('./addon.svg'),
  program: require('./program.svg'),
  event: require('./event.svg'),
  payment: require('./payment.svg'),
  promo: require('./promo.svg')
}
